export default __webpack_public_path__ + "static/media/gallery_08.d2726d41.jpg";